import React, { Children } from 'react';
import { motion } from 'framer-motion';
const categories = [{
  image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=400&fit=crop&q=80',
  count: 20,
  title: 'Ensaladas Refrescantes',
  description: 'Opciones ligeras, coloridas y rápidas, perfectas para el calor, desde combinaciones clásicas hasta propuestas exóticas y modernas.',
  accent: 'from-leaf/20 to-leaf-dark/10',
  border: 'border-leaf/30'
}, {
  image: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=400&h=400&fit=crop&q=80',
  count: 24,
  title: 'Recetas Gourmet Cocinadas',
  description: 'Platos elaborados con técnicas como asados, salteados, fermentados, sopas y estofados, con un enfoque más sofisticado y gastronómico.',
  accent: 'from-cabbage/20 to-cabbage-dark/10',
  border: 'border-cabbage/30'
}, {
  image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400&h=400&fit=crop&q=80',
  count: 10,
  title: 'Sándwiches Creativos',
  description: 'Recetas originales que aportan textura crujiente y frescura, ideales para comidas rápidas sin renunciar a lo saludable.',
  accent: 'from-gold/20 to-gold-light/10',
  border: 'border-gold/30'
}, {
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?w=400&h=400&fit=crop&q=80',
  count: 8,
  title: 'Batidos y Licuados',
  description: 'Combinaciones detox, energéticas y antioxidantes que aprovechan el repollo en crudo para potenciar todos sus beneficios.',
  accent: 'from-leaf/20 to-leaf-dark/10',
  border: 'border-leaf/30'
}, {
  image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400&h=400&fit=crop&q=80',
  count: 4,
  title: 'Encurtidos Artesanales',
  description: 'Preparaciones ricas en probióticos, pensadas para mejorar la salud digestiva y aportar sabores intensos y complejos.',
  accent: 'from-cabbage/20 to-cabbage-dark/10',
  border: 'border-cabbage/30'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Categories() {
  return <section className="py-12 md:py-24 bg-cabbage/10 relative overflow-hidden" data-id="element-33">
      {/* Julienne texture */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" data-id="element-34">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-35">
          <defs data-id="element-36">
            <pattern id="julienne-cat" x="0" y="0" width="80" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(15)" data-id="element-37">
              <path d="M0 20 Q20 15, 40 20 T80 20" fill="none" stroke="#5B2C6F" strokeWidth="2" data-id="element-38" />
              <path d="M0 8 Q20 3, 40 8 T80 8" fill="none" stroke="#5B2C6F" strokeWidth="1.2" data-id="element-39" />
              <path d="M0 32 Q20 27, 40 32 T80 32" fill="none" stroke="#5B2C6F" strokeWidth="1.2" data-id="element-40" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#julienne-cat)" data-id="element-41" />
        </svg>
      </div>

      <div className="container mx-auto px-5 md:px-6 max-w-6xl relative z-10" data-id="element-42">
        <div className="text-center mb-8 md:mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-5xl font-serif mb-3 md:mb-4 text-cabbage-dark" data-id="element-44">
            El Menú Completo
          </h2>
          <p className="text-cabbage-dark/70 max-w-2xl mx-auto text-base md:text-lg" data-id="element-45">
            Explora las infinitas posibilidades culinarias que ofrece este
            versátil ingrediente a través de nuestras 66 recetas.
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-46">
          {categories.map((cat, index) => <motion.div key={index} variants={itemVariants} className={`relative bg-white/90 backdrop-blur-sm p-5 md:p-8 rounded-2xl border-2 ${cat.border} hover:shadow-2xl transition-all duration-300 flex flex-col overflow-hidden ${index === 1 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-47">
              {/* Card accent gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${cat.accent} pointer-events-none`} data-id="element-48"></div>

              <div className="relative z-10" data-id="element-49">
                <div className="flex items-end justify-between mb-4 md:mb-6" data-id="element-50">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden ring-3 ring-white shadow-lg flex-shrink-0" data-id="element-51">
                    <img src={cat.image} alt={cat.title} className="w-full h-full object-cover" data-id="element-52" />
                  </div>
                  <span className="text-5xl md:text-6xl font-serif text-cabbage-dark/15 font-bold" data-id="element-53">
                    {cat.count}
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl font-serif mb-2 md:mb-3 text-cabbage-dark" data-id="element-54">
                  {cat.title}
                </h3>
                <p className="text-cabbage-dark/70 text-sm md:text-base leading-relaxed flex-grow" data-id="element-55">
                  {cat.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}